import { motion } from "framer-motion";
import { TRANSFORMATIONS } from "@/data/transformations";
import ImageCompareSlider from "@/components/ImageCompareSlider";

export default function Transformations() {
  return (
    <section
      id="transformations"
      data-testid="transformations-section"
      className="relative bg-cream py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <p className="text-[11px] tracking-[0.32em] uppercase text-ink mb-10">
          The Transformation
        </p>
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <h2 className="md:col-span-8 font-display font-light text-[10vw] md:text-[5.4vw] leading-[0.98] tracking-tightest text-charcoal">
            Before. <span className="italic text-brassDark">After.</span>
          </h2>
          <p className="md:col-span-4 text-ink text-lg leading-relaxed max-w-md">
            Drag the slider on each home to see what was — and what we made it.
          </p>
        </div>
      </div>

      <div className="mt-20 md:mt-28 space-y-24 md:space-y-32">
        {TRANSFORMATIONS.map((t, i) => (
          <motion.article
            key={t.id}
            data-testid="transformation-item"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="mx-auto max-w-[1400px] px-6 md:px-12"
          >
            <div className="grid md:grid-cols-12 gap-6 md:gap-10 items-center">
              <div
                className={`md:col-span-8 ${
                  i % 2 === 1 ? "md:order-2" : ""
                }`}
              >
                <div className="relative aspect-[16/10] border border-stone overflow-hidden">
                  <ImageCompareSlider
                    beforeImage={t.before}
                    afterImage={t.after}
                    altBefore={`${t.title} before`}
                    altAfter={`${t.title} after`}
                  />
                </div>
              </div>

              <div className="md:col-span-4">
                <span className="text-[11px] tracking-[0.3em] uppercase text-brassDark">
                  {t.audience} · N°{String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-5 font-display font-light text-3xl md:text-4xl text-charcoal leading-tight">
                  {t.title}
                </h3>
                <p className="mt-3 text-ink/80 text-sm tracking-[0.2em] uppercase">
                  {t.suburb}
                </p>
                <p className="mt-6 text-ink leading-relaxed max-w-md">
                  Drag the handle left or right to wipe between the original
                  kitchen and the finished home.
                </p>
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
